<script lang="ts">
  import type { AuthStatus } from './authStore';

  export let onSignIn: () => void;
  export let status: AuthStatus;
  export let error: string | null;

  $: busy = status === 'checking';
</script>

<div class="auth-screen" role="dialog" aria-modal="true" aria-labelledby="auth-title">
  <div class="auth-card">
    <h1 id="auth-title" class="auth-title">Acesso restrito · Pontotel</h1>
    <p class="auth-intro">
      Esta ferramenta é interna do time Pontotel. Entre com sua conta corporativa
      <strong>@pontotel.com.br</strong> para continuar.
    </p>
    {#if error}
      <p class="auth-error" role="alert">{error}</p>
    {/if}
    <button class="auth-btn" type="button" on:click={onSignIn} disabled={busy}>
      {busy ? 'Verificando...' : 'Entrar com Google Pontotel'}
    </button>
    <p class="auth-disclaimer">
      Apenas tokens são trocados com o Google. Nenhum arquivo AFD/AEJ é enviado nesta etapa
      — o princípio local-first segue íntegro.
    </p>
  </div>
</div>

<style>
  .auth-screen {
    position: fixed;
    inset: 0;
    background: var(--ptt-gray-300, #323232);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var(--ptt-space-4, 16px);
    z-index: 200;
  }
  .auth-card {
    background: var(--ptt-white, #fff);
    border-radius: var(--ptt-radius-md, 8px);
    padding: var(--ptt-space-6, 32px);
    max-width: 480px;
    width: 100%;
    box-shadow: var(--ptt-shadow-md, 0 4px 12px rgba(0,0,0,0.12));
  }
  .auth-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--ptt-black, #000);
    margin-bottom: var(--ptt-space-3, 12px);
  }
  .auth-intro {
    color: var(--ptt-gray-200, #565656);
    margin-bottom: var(--ptt-space-4, 16px);
    line-height: 1.5;
  }
  .auth-error {
    background: var(--ptt-red-10, #FEE);
    border-left: 3px solid var(--ptt-red-100, #C42121);
    color: var(--ptt-red-200, #8B1717);
    padding: var(--ptt-space-3, 12px);
    margin-bottom: var(--ptt-space-4, 16px);
    border-radius: var(--ptt-radius-sm, 4px);
  }
  .auth-btn {
    background: var(--ptt-yellow-100, #FCCC31);
    color: var(--ptt-black, #000);
    border: none;
    border-radius: var(--ptt-radius-sm, 4px);
    padding: var(--ptt-space-3, 12px) var(--ptt-space-5, 24px);
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    width: 100%;
  }
  .auth-btn:hover:not(:disabled) {
    background: var(--ptt-yellow-200, #F4B130);
  }
  .auth-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  .auth-disclaimer {
    margin-top: var(--ptt-space-4, 16px);
    font-size: 0.875rem;
    color: var(--ptt-gray-100, #7D7D7D);
    line-height: 1.5;
  }
</style>
